import React from "react";
import { Phone } from "@phosphor-icons/react";

export default function EmergencyButton() {
  return (
    <a
      href="tel:3114"
      data-testid="emergency-3114-btn"
      className="flex items-center gap-3 rounded-3xl bg-[#B56A63] px-5 py-4 text-white shadow-sm transition-transform hover:-translate-y-0.5"
    >
      <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white/20">
        <Phone size={22} weight="fill" />
      </div>
      <div className="flex-1">
        <p className="text-[15px] font-extrabold leading-tight">Besoin de parler maintenant ? 3114</p>
        <p className="text-[12.5px] text-white/85">Numéro national de prévention du suicide · 24h/24, 7j/7, gratuit</p>
      </div>
    </a>
  );
}
